/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaPage } from '../../models/criteria-page';
import { Page } from '../../models/page';

export interface ApiMasterPageGetByCriteriaPost$Params {
      body?: CriteriaPage
}

export function apiMasterPageGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterPageGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Page>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPageGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Page>>;
    })
  );
}

apiMasterPageGetByCriteriaPost.PATH = '/api/Master/Page/GetByCriteria';
